import { render } from "./ConteudoGeralView.vue?vue&type=template&id=015603a7&scoped=true"
import script from "./ConteudoGeralView.vue?vue&type=script&lang=js"
export * from "./ConteudoGeralView.vue?vue&type=script&lang=js"

import "./ConteudoGeralView.vue?vue&type=style&index=0&id=015603a7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-015603a7"]])

export default __exports__